<template>
  <div class="ll-member-list">
    <slot name="header" />
    <div class="ll-member-list_title">
      <div class="ll-member-list_title-item title">
        {{ `${$t('人員名稱')}/${$t('帳號')}` }}
      </div>
      <div class="ll-member-list_title_content">
        <div v-if="!hideRole" class="ll-member-list_title-item dropdown">
          {{ $t('角色設定') }}
        </div>
        <div
          v-if="!hideSystemClass"
          class="ll-member-list_title-item dropdown"
        >
          {{ $t('限閱領域') }}
        </div>
        <slot name="custom-title-item"/>
      </div>
      <div class="ll-member-list_title-item condition">
        {{ $t('狀態') }}
      </div>
    </div>
    <div class="ll-member-list_content">
      <div class="isloading">
        <LoadingProgressBar
          :isloading="isloading"
          @completed="$_hideProgress()"
        />
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlMemberList",
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    hideSystemClass: {
      type: Boolean,
      default: false,
    },
    hideRole: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showProgress: true,
      progressBarRate: 0,
      searchInputButton: {
        value: "",
        placeholder: this.$t("以姓名/帳號搜尋"),
      },
      addPopupActive: false,
      addAccountRemark: "",
      addAccountNumber: 1,
    };
  },
  watch: {
    isloading() {
      if (this.isloading) {
        this.$_showProgress();
      }
    },
  },
  methods: {
    $_showProgress() {
      this.showProgress = true;
    },
    $_hideProgress() {
      this.showProgress = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-member-list";
</style>